<template>
  <FormFieldWrapper :data="data">
    <div class="signature-container" :class="{ 'has-signature': !!modelValue }">
      <!-- Empty State: Sign Here Button -->
      <!-- Original:
      <Button 
        v-if="!modelValue"
        colorType="dark-blue" 
        @click="openSignatureModal"
      >
        <div style="display: flex; align-items: center; gap: 4px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.1029 10.39L20.1629 9.33C20.9429 8.55 20.9429 7.28 20.1629 6.5L18.7529 5.09C17.9729 4.31 16.7029 4.31 15.9229 5.09L14.8629 6.15L19.1029 10.39ZM14.8629 11.81L7.66293 19H6.25293V17.59L13.4429 10.4L14.8629 11.81ZM13.4429 7.56L4.25293 16.76V21H8.49293L17.6829 11.81L13.4429 7.56ZM19.2529 17.5C19.2529 19.69 16.7129 21 14.2529 21C13.7029 21 13.2529 20.55 13.2529 20C13.2529 19.45 13.7029 19 14.2529 19C15.7929 19 17.2529 18.27 17.2529 17.5C17.2529 17.03 16.7729 16.63 16.0229 16.3L17.5029 14.82C18.5729 15.45 19.2529 16.29 19.2529 17.5ZM4.83293 13.35C3.86293 12.79 3.25293 12.06 3.25293 11C3.25293 9.2 5.14293 8.37 6.81293 7.64C7.84293 7.18 9.25293 6.56 9.25293 6C9.25293 5.59 8.47293 5 7.25293 5C5.99293 5 5.45293 5.61 5.42293 5.64C5.07293 6.05 4.44293 6.1 4.02293 5.76C3.61293 5.42 3.53293 4.81 3.87293 4.38C3.98293 4.24 5.01293 3 7.25293 3C9.49293 3 11.2529 4.32 11.2529 6C11.2529 7.87 9.32293 8.72 7.61293 9.47C6.67293 9.88 5.25293 10.5 5.25293 11C5.25293 11.31 5.68293 11.6 6.32293 11.86L4.83293 13.35Z" fill="white"/>
          </svg>
          Sign Here
        </div>
      </Button>
      -->
      <ResponsiveButton
        v-if="!modelValue"
        display_name="Sign Here"
        button_type="filled"
        built_in_theme="dark"
        size="small"
        @click-button="openSignatureModal"
      >
        <template #prefix>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.1029 10.39L20.1629 9.33C20.9429 8.55 20.9429 7.28 20.1629 6.5L18.7529 5.09C17.9729 4.31 16.7029 4.31 15.9229 5.09L14.8629 6.15L19.1029 10.39ZM14.8629 11.81L7.66293 19H6.25293V17.59L13.4429 10.4L14.8629 11.81ZM13.4429 7.56L4.25293 16.76V21H8.49293L17.6829 11.81L13.4429 7.56ZM19.2529 17.5C19.2529 19.69 16.7129 21 14.2529 21C13.7029 21 13.2529 20.55 13.2529 20C13.2529 19.45 13.7029 19 14.2529 19C15.7929 19 17.2529 18.27 17.2529 17.5C17.2529 17.03 16.7729 16.63 16.0229 16.3L17.5029 14.82C18.5729 15.45 19.2529 16.29 19.2529 17.5ZM4.83293 13.35C3.86293 12.79 3.25293 12.06 3.25293 11C3.25293 9.2 5.14293 8.37 6.81293 7.64C7.84293 7.18 9.25293 6.56 9.25293 6C9.25293 5.59 8.47293 5 7.25293 5C5.99293 5 5.45293 5.61 5.42293 5.64C5.07293 6.05 4.44293 6.1 4.02293 5.76C3.61293 5.42 3.53293 4.81 3.87293 4.38C3.98293 4.24 5.01293 3 7.25293 3C9.49293 3 11.2529 4.32 11.2529 6C11.2529 7.87 9.32293 8.72 7.61293 9.47C6.67293 9.88 5.25293 10.5 5.25293 11C5.25293 11.31 5.68293 11.6 6.32293 11.86L4.83293 13.35Z" fill="white"/>
          </svg>
        </template>
      </ResponsiveButton>

      <!-- Signed State: Display Signature -->
      <div v-else class="signature-display">
        <div class="signature-text">{{ modelValue }}</div>
        <!-- Original:
        <button class="remove-signature-btn" @click="removeSignature">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 2.25V3H15V4.5H14.25V14.25C14.25 15.075 13.575 15.75 12.75 15.75H5.25C4.425 15.75 3.75 15.075 3.75 14.25V4.5H3V3H6.75V2.25H11.25ZM5.25 14.25H12.75V4.5H5.25V14.25ZM6.75 6H8.25V12.75H6.75V6ZM11.25 6H9.75V12.75H11.25V6Z" fill="#D10000"/>
          </svg>
          <span>Remove Signature</span>
        </button>
        -->
        <ResponsiveButton
          display_name="Remove Signature"
          button_type="text"
          built_in_theme="error"
          size="small"
          @click-button="removeSignature"
        >
          <template #prefix>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 2.25V3H15V4.5H14.25V14.25C14.25 15.075 13.575 15.75 12.75 15.75H5.25C4.425 15.75 3.75 15.075 3.75 14.25V4.5H3V3H6.75V2.25H11.25ZM5.25 14.25H12.75V4.5H5.25V14.25ZM6.75 6H8.25V12.75H6.75V6ZM11.25 6H9.75V12.75H11.25V6Z" fill="#D10000"/>
            </svg>
          </template>
        </ResponsiveButton>
      </div>
    </div>

    <!-- Signature Modal -->
    <SignatureModal
      :visible="isModalVisible"
      :data="data"
      :initialValue="modelValue"
      @close="closeSignatureModal"
      @save="handleSignatureSave"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';
import SignatureModal from './SignatureModal.vue';
// Original: import Button from '@/NewLibrary/Button.vue';
// Replaced with globally registered ResponsiveButton from @vibrant-wellness/va-responsive-components-library

export default {
  name: 'Signer',
  components: {
    FormFieldWrapper,
    SignatureModal,
    // Button, // replaced by globally registered ResponsiveButton
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isModalVisible: false
    };
  },
  emits: ['update:modelValue'],
  methods: {
    openSignatureModal() {
      this.isModalVisible = true;
    },
    closeSignatureModal() {
      this.isModalVisible = false;
    },
    handleSignatureSave(signatureName) {
      this.$emit('update:modelValue', signatureName);
      this.closeSignatureModal();
    },
    removeSignature() {
      this.$emit('update:modelValue', '');
    }
  }
};
</script>

<style scoped>
.signature-container {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #C4C4C4;
  border-radius: 5px;
  background: #F2F2F2;
  padding: 24px 64px;
}

.signature-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.signature-text {
  font-family: 'Brush Script MT', cursive;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  color: #333;
  text-align: center;
}

.remove-signature-btn {
  background: transparent;
  border: none;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.remove-signature-btn:hover {
  opacity: 0.8;
}

.remove-signature-btn span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #D10000;
  text-decoration: underline;
}
</style>
